$(document).ready(function(){
  
//   if(localStorage.getItem("quiz_cart")== 1){
    
//     $(".cart-sidebar-trigger").trigger("click");
//     localStorage.setItem("quiz_cart",0);

//   } else{
//    localStorage.setItem("quiz_cart",0);
//   }
  
  $(document).on('click','.selector-item',function(e){
    e.preventDefault();
    var parent = $(this).closest('.selectors'),
        gp = $(this).closest('.tabs'),
        target = $(this).attr('data-target');
    $(parent).find('.selector-item').removeClass('active');
    $(this).addClass('active');
    $(gp).find('.content').hide();
    $(gp).find('[data-selector="'+target+'"]').show();
  });

  $(document).on('click','.take-down-bottom a',function(e){
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $("#shopify-section-quiz-product-tabs").offset().top
    }, 2000);
  });
  function resetQuiz(){
    $(document).find('.quiz-form').trigger("reset");
    $(document).find('.result-recommended').html('');
    
    $(document).find('.quiz-questions-answers .steps').addClass('hidden');
    $(document).find('.quiz-questions-answers .steps:nth-child(1)').removeClass('hidden');
    $(document).find('.current-page').text('1');
  }

  $(document).on('click','.btn-take-quiz',function(){
    $('.quiz-section').show();
    resetQuiz();
    $('body').addClass('overflow-hidden');
  })

  $(document).on('click','.icon-close',function(){

    window.location.href="/pages/build-a-routine";
    // $('.quiz-section').hide();
    // resetQuiz();
    // $('body').removeClass('overflow-hidden');
    // $('.email-popup').hide();
    // $(document).find('.description-popup').hide();

  })

  function getProductData(url) {
    return $.ajax({
      url: url,
      type: 'GET',
      dataType: 'JSON',
      async : false,
      done: function(data){ 
        return data;
      }
    });
  }

  function buildResults(res){
    //sconsole.log(JSON.stringify(res));

    var result_html = '<ul class="result-recommended">',
        product_array = [];
    $.each(res,function(i,item){
      console.log(item.all_data);
      product_array.push(item.product_id);
      var moneyFormat=Flits.money_format
      var url = '/products/'+item.product_handle+'.js';
      var prodData = getProductData(url);
      var product = $.parseJSON(prodData.responseText);
      console.log($.parseJSON(prodData.responseText))
      var image = product.featured_image,
          title = item.product_title,
          handle = item.product_handle,
          frst_var = product.variants[0].id,
          price = Flits.formatMoney(product.price,moneyFormat),
          alldata = product;

      

      result_html += '<li><div class="pro-disp-flex"> <a class="left" target="_blank" href="/products/'+handle+'">';

      result_html += '<div class="image"><img src="'+image+'"></div>';
      result_html += '</a>';
      result_html += '<div class="add-to-cart"><div class="title_new_out"><div class="title">'+title+'<a class="_left" target="_blank" href="/products/'+handle+'">See full page →</a></div>';

      
      ///Variant selector 
      //var variant_d = JSON.stringify(item.all_data.variants);
      //console.log(variant_d)
      result_html += '<label>Select Size</label>';
      
//       $.each(alldata.variants,function(v , vitem){
//         result_html += '<option data-price="$'+vitem.price+'" value="'+vitem.id+'">'+vitem.title+'</option>';
//       })
      
      result_html += '<div class="pg__options gutter-ele-top w100"><div class="pg__option w100 swatch last" data-index="0" data-option-name="size"><div class="pg__option__values flex w100">';
    if(alldata){
      $.each(alldata.variants,function(v , vitem){  
        result_html += '<a href="#" title="'+vitem.title+'" data-value="'+vitem.title+'" data-price="'+Flits.formatMoney(vitem.price,moneyFormat)+'" data-variant-id="'+vitem.id+'" class="pg__option__value swatch__item text-center quiz_prd_item">'+vitem.title+'</a>';
      })  
    }
         
      result_html += '</div></div></div></div>';
        
      //result_html += '</select>';

      ///variant selector end
      result_html += '<button data-variant="'+frst_var+'" class="button--cart btn btn-custom btn-add-to-cart">'+theme_string.add_to_cart_btn+' <span>'+price+'</span></button></div></div>';
      //result_html += '<div class="product-description"><i title="View Details" class="fa fa-question-circle"></i><div class="description">'+alldata.body_html+'</div></div>';
      result_html += '</li>';

    });
    result_html += '</ul>';
    $(document).find('.quiz-loading-results').html(result_html);
    var prostring = product_array.join(',');
    $(document).find('#result_product_ids').val(prostring);
  }

  function getQuizresults(){
    var form = $(document).find('.quiz-form'),
        formdata = $(form).serialize();
    console.log(formdata);
    $.ajax({
      url: "https://www.timelesshapopquiz.com/quiz/sr/getQuizresult",
      type: 'POST',
      dataType: 'json', // added data type
      data:formdata,
      success: function(res) {
        buildResults(res);
      }
    });
  }

  function buildQuiz(res){
    
    var quiz_html = '',
        total_length = res.length+1,
        last_prev = parseInt(total_length)-1;
    $(document).find('.total-page').html(total_length)
    $.each(res,function(i,item){
      var answers = item.answers,
          classa="",
          step = parseInt(i)+1,
          prev = 0,
          next = step+1;

      if(i != 0 ){
        classa="hidden";
        prev = i;
      }
      if(i == 0){
        prev = 0;
      }
       quiz_html += '<div data-next="'+next+'" data-prev="'+prev+'" data-step="'+step+'" class="steps quiz-questions '+classa+'">';

      if(step==5){

         quiz_html += ' <div class="question-step5-step1-wrapper">';
      }
      quiz_html += ' <div class="question-title">'+item.question+'</div>';
      
      if(step==5){ 
      
        quiz_html += ' <div class="question-sub-title" style="color:#434343; margin-bottom:20px;">Select up to two</div>';
        
      }

      quiz_html += ' <div class="answers">';
      
      if(step==5){
        
        
        
        $.each(answers,function(k,ktm){

          var bclass="",
              style = '';
          if(ktm.image_url != ''){
            bclass="background-image";
            style = "background-image:url("+ktm.image_url+")";
          }
          quiz_html += '<div class="answer-'+ktm.id+' ans-item">';

          quiz_html += '<input id="anwers-'+ktm.id+'" class="ans_step_5" type="checkbox" name="answer_'+item.id+'" value="'+item.id+':'+ktm.id+'">';
          if(bclass != '' ){
            quiz_html += '<label class="step_'+step+'" for="anwers-'+ktm.id+'">';
            quiz_html += '<div class="bc-image"><img src="'+ktm.image_url+'"></div>';
            quiz_html += '<span class="ans-image-title">'+ktm.answer+'</span></label>';
          }else{
            quiz_html += '<label style="'+style+'" class="'+bclass+'" for="anwers-'+ktm.id+'">'+ktm.answer+'</label>';
          }
          quiz_html += '</div>';
          

        });
        
      }else{
        
      
        $.each(answers,function(k,ktm){

          var bclass="",
              style = '';
          if(ktm.image_url != ''){
            bclass="background-image";
            style = "background-image:url("+ktm.image_url+")";
          }
          quiz_html += '<div class="answer-'+ktm.id+' ans-item">';

          quiz_html += '<input id="anwers-'+ktm.id+'" type="radio" name="answer_'+item.id+'" value="'+item.id+':'+ktm.id+'">';
          if(bclass != '' ){
            quiz_html += '<label for="anwers-'+ktm.id+'">';
            quiz_html += '<div class="bc-image"><img src="'+ktm.image_url+'"></div>';
            quiz_html += '<span class="ans-image-title">'+ktm.answer+'</span></label>';
          }else{
            quiz_html += '<label style="'+style+'" class="'+bclass+'" for="anwers-'+ktm.id+'">'+ktm.answer+'</label>';
          }
          quiz_html += '</div>';

        });
        
      }
      
      quiz_html += '</div>';
      
      if(step==5){
       quiz_html += '<button class="next_5" style="text-align:center;display:none;">Next</button></div>';

       quiz_html += '<div class="question-step5-step2-wrapper" style="display:none;"><div class="question-title">Ready!</div><div class="step_2_img"><img src="https://cdn.shopify.com/s/files/1/1670/9243/t/57/assets/ready.png"></div><button class="show_me_btn" style="text-align:center;">Show me my personalized routine!</button></div>';
      }
      
      quiz_html += '</div>';
    });
    console.log(total_length +' '+last_prev);
//     quiz_html += '<div data-step="'+total_length+'" data-prev="'+last_prev+'" class="steps quiz-results hidden">';

//     quiz_html += '<div class="result-pops">';
//     quiz_html += '<div class="quiz-title"></div>';
//     //quiz_html += '<div class="left-part">';
//     quiz_html += '<div class="quiz-loading-results">Loading Result.....</div>';
//     quiz_html += '<button type="button" class="button--cart btn btn-result-bundle-products">'+theme_string.bundle_button_text+'</button>';
//     quiz_html += '<div class="quiz-description"></div>';
//     quiz_html += '<div class="custom-btns-disp"><button type="button" class="button--cart btn btn-send-result-email">'+theme_string.email_button_text+'</button>';
//     quiz_html += '<button type="button" class="button--cart btn btn-send-result-email" style = "display:none;">'+theme_string.download_button_text+'</button>';
    
//     quiz_html +='</div>';

// //     quiz_html += '<div class="right-part"><div class="quiz-loading-results">Loading Result.....</div></div>';


//     quiz_html +='</div></div>';
    
    quiz_html += '<div data-step="'+total_length+'" data-prev="'+last_prev+'" class="steps quiz-results hidden">';
    //let theme_string = '';
let theme_string; // Declare theme_string in a broader scope

if (!theme_string) {
    theme_string = ''; // Assign an empty string if it is falsy
}
    quiz_html += '<div class="result-pops">';
    quiz_html += '<div class="left-part">';
    quiz_html += '<div class="quiz-title"></div>';
    quiz_html += '<div class="quiz-description"></div>';
    quiz_html += '<div class="custom-btns-disp"><button type="button" class="button--cart btn btn-send-result-email">'+theme_string.email_button_text+'</button>';
    quiz_html += '<button type="button" class="button--cart btn btn-send-result-email" style = "display:none;">'+theme_string.download_button_text+'</button>';
    quiz_html += '<button type="button" class="button--cart btn btn-result-bundle-products">'+theme_string.bundle_button_text+'</button>';
    quiz_html +='</div></div>';

    quiz_html += '<div class="right-part"><div class="quiz-loading-results">Loading Result.....</div></div>';


    quiz_html +='</div><div class="quiz_new_question_section"><div class="page-width"><h2>HAVE ANY QUESTIONS?</h2><p>Reach out to our team of estheticians for a free consultation at <a href="#">consult@timelessha.com</a></p></div></div></div>';
    
    
    $(document).find('.quiz-questions-answers').html(quiz_html);
    setTimeout(function(){
      $(document).find('.quiz-title').html($(document).find('.quiz-title-dup').html());
      $(document).find('.quiz-description').html($(document).find('.quiz-description-dup').html());
    },1000)
  }

  $.ajax({
    url: "https://www.timelesshapopquiz.com/quiz/sr/getQuiz",
    type: 'GET',
    dataType: 'json', // added data type
    success: function(res) {
      //console.log(JSON.stringify(res))
      buildQuiz(res)
    }
  });

 $(document).on('click','.quiz-questions .answers label',function(){
   
    
    var parent = $(this).closest('.quiz-questions'),
        step = $(parent).attr('data-step'),
        next = $(parent).attr('data-next'),
        prev = $(parent).attr('data-prev'),
        current_step = $(parent).attr('data-step'),
        gp = (this).closest('.quiz-section'),
        total_result = parseInt($(document).find('.total-page').html());
     //alert(step);
    if(!$(this).hasClass('step_5')){
      
        if($('.quiz-questions-answers').hasClass('step-scroller')){
          $('.quiz-questions-answers').removeClass('step-scroller');
        }
        
      $(gp).find('.quiz-questions').addClass('hidden').removeClass('current');
      $(gp).find('[data-step="'+next+'"]').removeClass('hidden').addClass('current');
      $(gp).find('.current-page').text(next);
      var backsel = parseInt(next);
      if(backsel <= 1 ){
        $(gp).find('.back-button').css('opacity','0');
      }else{
        $(gp).find('.back-button').css('opacity','1');
      }
//       if( parseInt(next) == total_result){
//         setTimeout(function(){
//           getQuizresults();
//         },1000)
//       }
    }
    if($(this).hasClass('step_4')){
       $('.question-step5-step2-wrapper').hide();
          $('.question-step5-step1-wrapper').show();
    }
    if($(this).hasClass('step_5')){
      
      $('.quiz-questions-answers').addClass('step-scroller');
      
//       if($(this).closest('[type=checkbox]').is(':checked')){
//        alert($('input:checkbox.ans_step_5:checked').length);
//       }
      if($(this).prev().hasClass('checked')){
        
        $(this).prev().removeClass('checked');
        
        
        
      } else{
        
        if($('.ans_step_5:checked').length<2){
          
         $(this).prev().addClass('checked');
          
        } 
        if($('.ans_step_5:checked').length>1){
          //alert($('.ans_step_5:checked').length);
          $(this).prev('input:checkbox').trigger("click");
          //alert($('.ans_step_5:checked').length);
        }
        
        $('.next_5').show();
        
      }
      
      if($('.ans_step_5.checked').length==0){
        $('.next_5').hide();
      }

      $('.next_5').on('click',function(){
          $('.question-step5-step1-wrapper').hide();
          $('.question-step5-step2-wrapper').show();
      });
      
      $('.show_me_btn').on('click',function(){
        
        //if($('.ans_step_5.checked').length==2){
         if($('.quiz-questions-answers').hasClass('step-scroller')){
          $('.quiz-questions-answers').removeClass('step-scroller');
        }
        
        $(gp).find('.quiz-questions').addClass('hidden').removeClass('current');
        $(gp).find('[data-step="'+next+'"]').removeClass('hidden').addClass('current');
        $(gp).find('.current-page').text(next);
        var backsel = parseInt(next);
        if(backsel <= 1 ){
          $(gp).find('.back-button').css('opacity','0');
        }else{
          $(gp).find('.back-button').css('opacity','1');
        }
        if( parseInt(next) == total_result){
          setTimeout(function(){
            getQuizresults();
          },1000)
        }
        
      //}
        
     });
      
    }
    
  });

  $(document).on('click','.back-button',function(){
    var gp = (this).closest('.quiz-section'),
        current = $(gp).find('.current'),
        prev = $(current).attr('data-prev'),
        next = $(current).attr('data-next'),
        total_result = parseInt($(document).find('.total-page').html());
    //alert($(current).attr('data-step'));
    if($(current).attr('data-step')==5){
       if($('.quiz-questions-answers').hasClass('step-scroller')){
          $('.quiz-questions-answers').removeClass('step-scroller');
        }
      $('.question-step5-step2-wrapper').hide();
      $('.question-step5-step1-wrapper').show();
    }
    if($(current).attr('data-step')==4){
      $('.question-step5-step2-wrapper').hide();
      $('.question-step5-step1-wrapper').show();
    }
    if($(current).attr('data-step')==6){
       
          $('.quiz-questions-answers').addClass('step-scroller');
          $('.question-step5-step2-wrapper').hide();
          $('.question-step5-step1-wrapper').show();
    }

    $(document).find('.quiz-results').removeClass('current').addClass('hidden');

    $(gp).find('.quiz-questions').addClass('hidden').removeClass('current');
    $(gp).find('[data-step="'+prev+'"]').removeClass('hidden').addClass('current');
    $(gp).find('.current-page').text(prev);
    console.log(prev)
    var backsel = parseInt(prev);
    if(backsel <= 1 ){
      $(gp).find('.back-button').css('opacity','0');
    }else{
      $(gp).find('.back-button').css('opacity','1');
    }
  });

  function updateCart(){
    $.ajax({
      url: "/cart.js",
      type: 'GET',
      dataType: 'json', // added data type
      success: function(cart) {
        console.log(cart);
        var itemcount = cart.item_count;
        $(".cart-number").text(itemcount);
        //$(document).find('.cart_count').text(itemcount);
        //localStorage.setItem("quiz_cart", 1);
        //location.reload();
        
      }
    });
  }
  function addTocart(v,q){
    
    //alert(v);
    return $.ajax({
      url: "/cart/add.js",
      type: 'POST',
      data:{id:v,quantity:q},
      dataType: 'json', // added data type
      success: function(res) {
        $('body').removeClass('loading');
        updateCart();
      }
    });
  }
  
  $(document).on('click','.quiz_prd_item',function(e){
    $('.quiz_prd_item').removeClass('active');
    $(this).addClass('active');
    var d_v = $(this).attr('data-variant-id');
    $(this).parent().parent().parent().parent().next().attr('data-variant',d_v);
    
    $(this).parent().parent().parent().next().attr('data-variant',d_v);
    
    var parent = $(this).closest('.add-to-cart');
    
    var price = $(this).attr('data-price');
    
     $(this).parent().parent().parent().parent().next().find('span').text(price);
    
     $(this).parent().parent().parent().next().find('span').text(price);
//         quantity = 1;
//     $('body').addClass('loading');
//     var id = addTocart(id,quantity);
    //console.log(id);
  })
  
//   $(document).on('click','.btn-add-to-cart',function(e){
//     e.preventDefault();
//     var id = $(this).attr('data-variant'),
//         quantity = 1;
//     $('body').addClass('loading');
//     var id = addTocart(id,quantity);
//     //console.log(id);
//   })

  $(document).on('click','.btn-send-result-email',function(){
    $(document).find('.email-popup').show();
  });

  $(document).on('click','.close-btn-email',function(){
    $(document).find('.email-popup').hide();
  });

  $(document).on('click','.btn-send-email',function(){
    var form = $(document).find('.quiz-form'),
        formdata = $(form).serialize(),
        selector = $(this);
    $(this).addClass('disabled').html('Sending...');
    $.ajax({
      url: "https://www.timelesshapopquiz.com/quiz/sr/sendEmail",
      type: 'POST',
      dataType: 'json', // added data type
      data:formdata,
      success: function(res) {
        var message = res.message;
        $(selector).removeClass('disabled').html('Send');
        $(document).find('.success-message').text(message)
      }
    });
  });
  $(document).on('click','.product-description .fa',function(){
    var parent = $(this).closest('.product-description'),
        desc = $(parent).find('.description').html();
    $(document).find('.description-popup .description-here').html(desc);
    $(document).find('.description-popup').show();
  });

  $(document).on('click','.close-btn-description',function(){
    $(document).find('.description-popup').hide();
    $(document).find('.description-popup .description-here').html('');
  });
  $(document).on('change','.add-to-cart .variant',function(){
    var parent = $(this).closest('.add-to-cart');
    var id = $(this).val(),
        price = $(this).find('option:selected').attr('data-price');
    console.log(price+' '+id);
    $(parent).find('.btn-add-to-cart').attr('data-variant',id).find('span').text(price);
  });

//   $(document).on('click','.btn-result-bundle-products',function(){
//     var tr = $(document).find('.quiz-results ul.result-recommended>li').length-1;
//     $('body').addClass('loading');

//     setTimeout(function(){
//       $(document).find('.quiz-results ul.result-recommended>li').each(function(i,item){
//         var id = $(this).find('.btn-add-to-cart').attr('data-variant');
//         if(id !== undefined){
//           console.log(i +'  '+tr );
//          // console.log(id);
//           $.ajax({
//             url: "/cart/add.js",
//             type: 'POST',
//             data:{id:id,quantity:1},
//             dataType: 'json', // added data type
//             async:false,
//             success: function(res) {
//               if(i == tr){
//                 //$('body').removeClass('loading');
//                // window.location.href="/cart";
//                 var itemcount = res.item_count;
//                 $(".cart-number").text(itemcount);
//                // $(document).find('.cart_count').text(itemcount);
//                 localStorage.setItem("quiz_cart", 1);
//                 location.reload();
//               }
//             },
//             error:function(){
//               if(i == tr){
//                 //$('body').removeClass('loading');
//                 //window.location.href="/cart";
//               }
//             }
//           });
//         }
//       });
//     },500)
//   });

  $('.product_price__var_wrapInner').mouseenter(function(){
    $(this).parents('.pg__bottom').prev('.item__top').find('.pg__lbs').css("z-index", 1);
  }).mouseleave(function() {
    $(this).parents('.pg__bottom').prev('.item__top').find('.pg__lbs').css("z-index", 0);
  });

});